// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__2pBDF","lastUpdated":"PrivacyPolicy_lastUpdated__2zDLP","italic":"PrivacyPolicy_italic__Tg7hf","bold":"PrivacyPolicy_bold__1Yq_X"};